import React from 'react';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FieldTable2 } from 'components/_basic/Form/FieldTable2';
import { FormSectionFilledCard } from 'components/_basic/FormSectionFilledCard';
import {
  GLOBAL_PERIOD_NAME,
  GLOBAL_PERIOD_TABLE_HEADINGS_NAME,
} from 'components/BusinessToolForm/Sections/Global/form';

import { getPeriodColumnsNames } from 'helpers/businessTool';
import { concatWithDot } from 'helpers/string';

import { IProfitabilityFormTableProps } from './types';
import { profitabilityFormPrefix } from '../../../utils/form';
import { PROFITABILITY_FORM_NAMES } from '../../utils/form';

const FIRST_COLUMN_WIDTH = 165;

export const ProfitabilityFormTable: React.FC<IProfitabilityFormTableProps> = ({ disabled }) => {
  const { control } = useFormContext();
  const { t } = useTranslation();

  const period = useWatch({ name: GLOBAL_PERIOD_NAME });

  const tableName = concatWithDot(profitabilityFormPrefix, PROFITABILITY_FORM_NAMES.PROFITABILITY_TABLE);
  const { fields } = useFieldArray({ control, name: tableName });

  const columnsNames = getPeriodColumnsNames(period) ?? [];

  const variantsName = concatWithDot(
    profitabilityFormPrefix,
    PROFITABILITY_FORM_NAMES.PROFITABILITY_VARIANTS,
    ':index',
  );

  const tableTotalName = concatWithDot(profitabilityFormPrefix, PROFITABILITY_FORM_NAMES.PROFITABILITY_TOTAL);

  return (
    <FormSectionFilledCard>
      <FieldTable2
        showSumRow
        rows={fields}
        name={tableName}
        disabled={disabled}
        headerName={GLOBAL_PERIOD_TABLE_HEADINGS_NAME}
        totalName={tableTotalName}
        columnsNames={columnsNames ?? []}
        watchRowTitleName={variantsName}
        firstColumnWidth={FIRST_COLUMN_WIDTH}
        totalRowTitle={t('financialPlan.financialPerformance.profitability.netProfit')}
        readOnly
      />
    </FormSectionFilledCard>
  );
};
